import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入jQuery
import $ from 'jquery'
// 引入layui
import '../static/libs/layui/layui.all.js'
import '../static/libs/layui/css/layui.css'
// 引入elementui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 全局常量
import global from './config/global.js'; // 引入配置文件
// 引入公共css
import './common/css/common.css';
import "babel-polyfill"; // Vue官方明确说明不支持IE8，但是可以兼容IE9及以上，这里是es6语法转换，用于兼容IE9及以上
import {
    get,
    post,
    upload
} from './http/axios'; // 引入封装的网络请求
import axios from 'axios';
import cookie from './utils/cookieUtils';
import md5 from 'js-md5';
// console
// import Vconsole from 'vconsole';
// let vConsole = new Vconsole();
// export default vConsole

Vue.use(ElementUI);
// 事件总线
Vue.prototype.$event = new Vue();
Vue.prototype.$global = global; // 全局定义配置文件
Vue.prototype.$get = get; // 全局定义axios的get方法
Vue.prototype.$post = post; // 全局定义axios的post方法
Vue.prototype.$upload = upload; // 全局定义axios的upload方法
Vue.prototype.$axios = axios; // 全局定义axios
Vue.prototype.$cookie = cookie; // 全局定义cookie类
Vue.prototype.$md5 = md5; // 全局定义md5

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')